import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PriceRangeMin from './PriceRangeMin';
import PriceRangeMax from './PriceRangeMax';

const currencies = {
    getCurrency(name) {
        return Object.keys(this.values).find(currency => currency === name) ?
            this.values[name] :
            name;
    }
};

const CURRENCIES = Object.create(currencies);
CURRENCIES.values = {
    EUR: '€',
    GBP: '£',
    USD: '$'
};

function parsePrice(input) {
    return Math.max(parseInt(input, 10) || 0, 0);
}

class PriceRangeFilter extends Component {
    static propTypes = {
        minPrice: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        minPriceOnChange: PropTypes.func.isRequired,
        maxPrice: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        maxPriceOnChange: PropTypes.func.isRequired,
        disabled: PropTypes.bool.isRequired,
        currency: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.handleChangePriceMin = this.handleChangePriceMin.bind(this);
        this.handleChangePriceMax = this.handleChangePriceMax.bind(this);
    }

    handleChangePriceMin(event) {
        const parsedValue = parsePrice(event.target.value);
        this.props.minPriceOnChange(parsedValue || null);
    }

    handleChangePriceMax(event) {
        const parsedValue = parsePrice(event.target.value);
        this.props.maxPriceOnChange(parsedValue || null);
    }

    render() {
        return (
            <div className="PriceRangeFilter">
                <PriceRangeMin
                    value={this.props.minPrice}
                    onChange={this.handleChangePriceMin}
                    disabled={this.props.disabled}
                    currency={CURRENCIES.getCurrency(this.props.currency)}
                />
                <PriceRangeMax
                    value={this.props.maxPrice}
                    onChange={this.handleChangePriceMax}
                    disabled={this.props.disabled}
                    currency={CURRENCIES.getCurrency(this.props.currency)}
                />
            </div>
        );
    }
}

export default PriceRangeFilter;



// WEBPACK FOOTER //
// ./src/js/modules/PriceRangeFilter/components/index.js